import React from "react";
import { MobilePageHeader } from "../layout/MobileAppChrome";
import "../../styles/pages/InfoPage.css";

interface InfoPageLayoutProps {
  eyebrow: string;
  title: string;
  intro?: string;
  variantClassName?: string;
  sections: Array<{
    heading: string;
    paragraphs: string[];
  }>;
}

const InfoPageLayout: React.FC<InfoPageLayoutProps> = ({
  eyebrow,
  title,
  intro,
  variantClassName,
  sections,
}) => {
  return (
    <section className={`shell section page-section info-page-layout${variantClassName ? ` ${variantClassName}` : ""}`}>
      <div className="info-page-layout__mobile-header">
        <MobilePageHeader title={title} />
      </div>
      <div className="page-header info-page-header">
        <span className="eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        {intro ? <p>{intro}</p> : null}
      </div>

      <div className="info-page-stack">
        {sections.map((section) => (
          <article key={section.heading} className="store-card info-page-card">
            <h2>{section.heading}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </article>
        ))}
      </div>
    </section>
  );
};

export default InfoPageLayout;
